import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Demonstrates feature ports being referenced by downstream elements.
 *
 * Setup:
 * 1. Triangle t1 (a=6, b=8, gamma=50°)
 * 2. Altitude from vertex A → registers `alt.foot` and `alt.length` ports
 * 3. Circle centered at the altitude foot, with radius = altitude length
 *    — uses center PointTarget to position at alt.foot
 * 4. Equilateral triangle with side = median length
 *    — proves scalar feature ports work in shape param expressions
 */
export const FEATURE_PORTS_PRESET: GeometryPadWidgetConfig = {
  id: 'feature-ports',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 6, b: 8, gamma: 50 },
      },
      alt: { type: 'Altitude', params: { of: 't1', from: 'A' } },
      med: { type: 'Median', params: { of: 't1', from: 'B' } },
      // Circle whose center is at the altitude foot via cx/cy expressions
      c1: {
        type: 'Circle',
        params: { center: { x: 'alt.foot.x', y: 'alt.foot.y' }, r: 'alt.length' },
      },
      // Equilateral triangle with side = median length
      t2: {
        type: 'Triangle',
        params: { a: 'med.length', b: 'med.length', gamma: 60 },
      },
    },
  },
  display: {
    geometry: {
      label: { names: 'tiered', values: 'tiered', coloring: true },
    },
  },
};
